<template>
  <div
    class="order-history tw-w-full tw-h-full tw-min-h-0 tw-flex tw-flex-col tw-text-left tw-space-y-6 tw-py-2"
  >
    <div
      class="user-info tw-flex-none tw-p-2 tw-border tw-rounded-lg tw-text-sm tw-relative"
    >
      <span
        class="group-header tw-absolute tw-top-[-0.75rem] tw-font-bold tw-bg-white tw-px-2"
        >Customer Information</span
      >
      <div v-if="customer" class="content tw-space-y-1 tw-p-2">
        <div class="name"><strong>Name: </strong>{{ customer.Name }}</div>
        <div class="phone">
          <strong>Phone: </strong>{{ customer.PhoneNumber }}
        </div>
        <div class="phone"><strong>Email: </strong>{{ customer.Email }}</div>
        <!-- <div class="id">
          <strong>ID:</strong> 84274cb8-1850-437b-98e1-b6e4897b8821
        </div> -->
      </div>
      <div class="" v-else>Invalid customer infomation.</div>
    </div>
    <div
      class="user-info tw-flex-grown tw-flex tw-flex-col tw-min-h-0 tw-p-2 tw-border tw-rounded-lg tw-text-sm tw-relative"
    >
      <span
        class="group-header tw-absolute tw-top-[-0.75rem] tw-font-bold tw-bg-white tw-px-2"
        >Order History</span
      >
      <form class="tw-flex-none tw-items-center tw-py-2">
        <div class="tw-relative tw-w-full">
          <div
            class="tw-flex tw-absolute tw-inset-y-0 tw-left-0 tw-items-center tw-pl-2 tw-pointer-events-none"
          >
            <svg
              class="tw-w-4 tw-h-4 tw-text-gray-500 dark:tw-text-gray-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <input
            v-model="filter"
            type="text"
            class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-sm tw-rounded-lg focus:tw-ring-primary focus:tw-border-primary tw-block tw-w-full tw-pl-7 tw-p-2"
            placeholder="Search"
          />
        </div>
      </form>
      <div class="tw-flex-none tw-flex tw-justify-center" v-if="loading">
        <svg
          role="status"
          class="tw-w-8 tw-h-8 tw-mr-2 tw-text-gray-200 tw-animate-spin tw-fill-primary-light"
          viewBox="0 0 100 101"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          ></path>
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          ></path>
        </svg>
      </div>
      <div
        v-else-if="filteredOrders.length <= 0"
        class="content tw-flex-none tw-space-y-1"
      >
        No order history.
      </div>
      <div
        v-else
        class="content order-list tw-flex-auto tw-min-h-0 tw-flex tw-overflow-auto tw-flex-col tw-space-y-2"
      >
        <OrderCard
          v-for="order in filteredOrders"
          :key="order.orderId"
          :order="order"
          @detail="onOrderCardDetail"
        ></OrderCard>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "OrderHistory",
  props: {
    customer: Object,
  },
  components: {
    OrderCard: () => import("./OrderCard.vue"),
  },
  data() {
    return {
      orders: [],
      filter: "",
      loading: true,
    };
  },
  // async mounted() {},
  computed: {
    ...mapGetters({
      selectedRoomID: "chat/selectedRoomID",
      room: "chat/room",
    }),
    // currentCustomer() {
    //   return this.room?.MainChannel?.Participants?.find(
    //     (p) => p.Type === "customer"
    //   );
    // },
    filteredOrders() {
      if (this.filter) {
        return this.orders.filter((o) => {
          if (o.orderId.search(this.filter) >= 0) {
            return true;
          }
          return false;
        });
      }
      return this.orders;
    },
  },
  methods: {
    onOrderCardDetail(orderID) {
      console.log("onOderCardDetail", orderID);
      this.$emit("order-detail", orderID);
    },
  },
  watch: {
    selectedRoomID: {
      immediate: true,
      handler: function () {
        this.orders = [];
        this.loading = true;
      },
    },
    customer: {
      immediate: true,
      handler: async function (value) {
        console.log("current customer", value);
        this.loading = true;
        this.orders = await this.$store.dispatch("chat/getOrderHistory", {
          userId: value.ID,
        });
        this.loading = false;
      },
    },
  },
};
</script>

<style scoped>

/* *{
  border: 1px solid red;
} */

.rooms::-webkit-scrollbar,
.message::-webkit-scrollbar,
.note-list::-webkit-scrollbar,
.order-list::-webkit-scrollbar {
  width: 6px;
  background-color: transparent;
}
.rooms::-webkit-scrollbar-thumb,
.message::-webkit-scrollbar-thumb,
.note-list::-webkit-scrollbar-thumb,
.order-list::-webkit-scrollbar-thumb {
  max-height: 10%;
  border-radius: 10px;
  background: #cbd5e1;
}

</style>
